// Controls that initiate or display device location remain available while
// permission is unresolved, but must disappear once the browser has confirmed
// that location cannot be used.
export function canShowGeolocationControls(permission) {
  return permission !== "denied" && permission !== "unsupported";
}
